export default {
  "yourAchievement": "Votre succès",
  "qualificationRecords": "Qualifications et dossiers",
  "recordedActivity": "Activité enregistrée",
  "exceptional": "Résultats exceptionnels",
  "historicalPar": "Des instantanés de trous historiques ou des scores de trous enregistrés par rapport au par sont nécessaires; le cours par d'aujourd'hui n'est pas utilisé.",
  "matchResult": "Le résultat a besoin d'un score final soutenu et gagnant. Les séances décontractées, les retraites et les matchs inachevés n'établissent pas de match complet.",
  "title": "Réalisations",
  "allCategories": "Toutes les catégories",
  "informationLabel": "À propos des résultats obtenus",
  "intro": "Vos jalons de la vie au club.",
  "all": "Tous",
  "earned": "Gagnés",
  "in_progress": "En cours",
  "history_incomplete": "L'histoire enregistrée est limitée",
  "source_unavailable": "Source temporairement indisponible",
  "not_applicable": "Sans objet",
  "category": "Catégorie",
  "membership": "Adhésion",
  "heritage": "Patrimoine familial",
  "golf": "Golf",
  "racquet": "Sports de raquette",
  "events": "Manifestations au Club",
  "spa": "Spa",
  "academy": "Académie",
  "loading": "Chargement des réalisations...",
  "error": "Vos réalisations n'ont pas pu être chargées.",
  "retry": "Réessayer",
  "empty": "Aucune réalisation ne correspond à ces filtres.",
  "close": "Fermer",
  "details": "Détails du prix",
  "tiers": "Toutes les étapes familiales",
  "milestones": "Jalons",
  "earnedDate": "Enseigné sur",
  "unknownDate": "La date exacte n'est pas connue.",
  "partial": "Les progrès reflètent les documents disponibles; l ' histoire antérieure peut être manquante.",
  "pending": "Vos dossiers sont évalués.",
  "next": "Suivant",
  "future": "Avenir",
  "starting": "Pas encore gagné.",
  "notEarned": "Pas encore gagné",
  "complete": "Toutes les étapes gagnées",
  "progressUnknown": "Progrès non disponibles",
  "source": "Source",
  "bookingPolicy": "Les réservations programmées comptent à partir du prochain jour civil après leur date prévue finale, dans le fuseau horaire du club. Les réservations annulées et les non-présentations ne comptent pas.",
  "heritagePolicy": "Les liens familiaux existants relient les périodes d'adhésion connues, y compris les ancêtres par le biais de liens parent/enfant. Les liens non datés utilisent la relation familiale existante; les périodes de chevauchement comptent une fois.",
  "automaticHelp": "Mise à jour des prix automatiquement. Corrigez les dates d'adhésion, les liens familiaux, les réservations et les scores dans leurs workflows originaux.",
  "history": "Réalisations / Histoire",
  "audit": "Historique de l ' administration pénitentiaire et de la délivrance",
  "reconcile": "Demande de réconciliation",
  "saved": "La réconciliation est bloquée.",
  "staffError": "La demande n'a pas pu être complétée. Essayez de nouveau.",
  "more": "Charger plus d'histoire",
  "awards": {
    "membership_1": "Premier anniversaire",
    "membership_5": "Cinq ans ensemble",
    "membership_10": "Décennie des États Membres",
    "membership_20": "Vingt ans ensemble",
    "membership_25": "Siècle",
    "membership_50": "Cinquante ans ensemble",
    "heritage_25": "Patrimoine · 25 Années",
    "heritage_50": "Patrimoine · 50 Années",
    "heritage_75": "Patrimoine · 75 ans",
    "heritage_100": "Patrimoine · 100 ans",
    "golf_rounds_1": "Premier tee",
    "golf_rounds_10": "Trouver votre Swing",
    "golf_rounds_50": "Chenal régulier",
    "golf_rounds_100": "Siècle des Rondes",
    "golf_ace_1": "Trou en un",
    "golf_under_par_1": "Sous le par",
    "racquet_matches_1": "Premier servi",
    "racquet_matches_10": "Dans le rallye",
    "racquet_matches_50": "Cour régulière",
    "racquet_matches_100": "Siècle à la cour",
    "racquet_perfect_1": "Match parfait",
    "events_1": "Partie du Club",
    "events_10": "Cercle social",
    "events_20": "Club régulier",
    "events_50": "Rencontre amicale",
    "spa_1": "Un moment pour toi",
    "spa_10": "Rituel de bien-être",
    "spa_25": "Temps bien passé",
    "academy_1": "Un nouveau chapitre",
    "academy_5": "Apprentis à vie"
  },
  "qualifications": {
    "membership_1": "Atteindre 1 an d'adhésion continue.",
    "membership_5": "Atteindre 5 ans d'adhésion continue.",
    "membership_10": "Atteindre 10 ans d'adhésion continue.",
    "membership_20": "Atteinte 20 ans d'adhésion continue.",
    "membership_25": "Atteindre 25 ans d'adhésion continue.",
    "membership_50": "Atteint 50 ans d'adhésion continue.",
    "heritage_25": "Atteindre 25 ans d'appartenance à la famille, en comptant des périodes de chevauchement une fois.",
    "heritage_50": "Atteindre 50 ans d'appartenance à la famille, en comptant des périodes de chevauchement une fois.",
    "heritage_75": "Atteindre 75 ans d'appartenance à la famille, en comptant des périodes de chevauchement une fois.",
    "heritage_100": "Atteindre 100 ans d'appartenance à la famille, en comptant des périodes de chevauchement une fois.",
    "golf_rounds_1": "Complet 1 parcours de golf enregistré.",
    "golf_rounds_10": "Complet 10 tours de golf enregistrés.",
    "golf_rounds_50": "Complet 50 tours de golf enregistrés.",
    "golf_rounds_100": "Complet 100 tours de golf enregistrés.",
    "golf_ace_1": "Enregistrez un trou joué valide en un seul coup.",
    "golf_under_par_1": "Remplissez une ronde brute en dessous de son historique enregistré par.",
    "racquet_matches_1": "Complète 1 match de raquette.",
    "racquet_matches_10": "Complet 10 matchs de raquette.",
    "racquet_matches_50": "Complet 50 matchs de raquette.",
    "racquet_matches_100": "Complète 100 matchs de raquette.",
    "racquet_perfect_1": "Gagnez un match de tennis ou de padel pris en charge sans concevoir un jeu.",
    "events_1": "Avoir 1 réservation d'événements antérieurs admissibles.",
    "events_10": "Avoir 10 réservations d'événements antérieurs admissibles.",
    "events_20": "Avoir 20 réservations d'événements passés admissibles.",
    "events_50": "Avoir 50 réservations d'événements passés admissibles.",
    "spa_1": "Avoir 1 traitement de spa passé admissible.",
    "spa_10": "Avoir 10 traitements de spa antérieurs admissibles.",
    "spa_25": "Avoir 25 traitements de spa antérieurs admissibles.",
    "academy_1": "Terminer 1 programme de l'Académie par des inscriptions programmées ou l'achèvement en ligne enregistré.",
    "academy_5": "Terminer 5 programmes de l ' Académie par le biais d ' inscriptions programmées ou de l ' achèvement en ligne."
  }
};
